
import { NodeSelector } from "@/components/NodeSelector";
import { NodeFinder } from "@/components/NodeFinder";
import { NetworkStats } from "@/components/NetworkStats";
import { NodeDashboard } from "@/components/NodeDashboard";
import { ThemeToggle } from "@/components/ThemeToggle";
import { DonationsButton } from "@/components/DonationsButton";
import { ApiTestButton } from "@/components/ApiTestButton";
import { TelegramSetup } from "@/components/TelegramSetup";
import { EventAnnouncer } from "@/components/EventAnnouncer";
import { NodeSelectionProvider } from "@/contexts/node-selection";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useMarketDataRefresher } from "@/hooks/useMarketDataRefresher";
import { UrgentBanner } from "@/components/UrgentBanner";

export default function Index() {
  useMarketDataRefresher();
  return (
    <TooltipProvider delayDuration={0}>
      <NodeSelectionProvider>
        <div className="min-h-screen flex flex-col">
          <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
            <div className="container flex h-14 items-center">
              <div className="mr-4 flex">
                <a className="mr-6 flex items-center space-x-2 font-bold" href="/">
                  <img 
                    src="/lovable-uploads/dedf2232-1eee-497f-8010-e51744f61158.png" 
                    alt="Dusk Logo" 
                    className="h-6 w-6"
                  />
                  <span>Dusk Network</span>
                </a>
              </div>
              <div className="flex flex-1 items-center space-x-2">
                <NodeSelector />
                <NodeFinder />
              </div>
              <div className="ml-auto flex items-center space-x-2">
                <DonationsButton />
                <ThemeToggle />
              </div>
            </div>
          </header>

          <UrgentBanner />

          <main className="flex-1">
            <div className="container py-8">
              {/* Development/Admin components - hidden from public */}
              {/* <div className="mb-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <ApiTestButton />
                <TelegramSetup />
                <EventAnnouncer />
              </div> */}
              <NetworkStats />
              <div className="mt-8">
                <NodeDashboard />
              </div>
            </div>
          </main>
        </div>
      </NodeSelectionProvider>
    </TooltipProvider>
  );
}
